package app.smartcoding.realrate.platform

import kotlinx.browser.window

actual fun getSystemLanguage(): String {
    val fullTag = window.navigator.language
    return fullTag.split("-").firstOrNull() ?: "en"
}
